import React from "react";

export default function SectionServiceStickyLinks() {
  return (
    <div>
      <div class="fixed -top-20 left-10">Fixed child</div>{" "}
    </div>
  );
}
